export default "__VITE_ASSET__42c90126__"